import React from "react";
import { Routes as ReactRoutes, Route } from "react-router-dom";
import { RouteObject } from "../interfaces/navigation";
import SuspenseLoader from "../components/SuspenseLoader";
import { notFoundPageRoutes } from "../pages/NotFoundPage/routes";
import { homeRoutes } from "../pages/Home/routes";
import { buyRoutes } from "../pages/Buy/routes";
import { termsRoutes } from "../pages/Terms/routes";

const Routes = () => {

    const allRoutes: RouteObject[] = [
        ...notFoundPageRoutes,
        ...homeRoutes,
        ...buyRoutes,
        ...termsRoutes
    ];

    return (
        <ReactRoutes>
            {allRoutes.map((route: any) => (
                <Route
                    key={route.path}
                    path={route.path}
                    element={
                        <React.Suspense fallback={
                            <SuspenseLoader />
                        }>
                            {route.component}
                        </React.Suspense>
                    }
                >
                    {route?.subRoutes?.map((subRoute: any, index: number) => {
                        return  <Route
                                    path={subRoute.path}
                                    key={"subRoute-" + index}
                                    element={subRoute.component}>
                                    {subRoute?.subRoutes?.map((subSubRoute: any, index: number) => (
                                        <Route
                                            path={subSubRoute.path}
                                            key={"subSubRoute-" + index}
                                            element={subSubRoute.component}
                                        > 
                                            {
                                                subSubRoute?.subRoutes?.map((subSubSubRoute: any) => (
                                                    <Route
                                                        path={subSubSubRoute.path}
                                                        key={"subSubSubRoute-" + index}
                                                        element={subSubSubRoute.component}
                                                    /> 
                                                ))
                                            }
                                        </Route>
                                    ))}
                                </Route>
                    })}
                </Route>
            ))}
            <Route 
                path='*' 
                element={
                    <React.Suspense fallback={
                        <SuspenseLoader />
                    }>
                        {notFoundPageRoutes[0].component}
                    </React.Suspense>
                } 
            />
        </ReactRoutes>
    )
};

export default Routes;